import React from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import { Button, Box, Link } from "@bca/ui-library";

import { CONTACT_US_URL } from "../utils/page-urls";
import {
  MessageIcon,
  Message,
  MessageOptionsContainer,
} from "../common/components/messages";
import MessageTheme from "../common/components/messages/themes/EmbeddedMessageTheme";
import { TRACKED } from "../constants";

const StyledLink = styled(Link)`
  text-decoration: underline;
`;

interface SomethingWentWrongProps {
  onRetryClick: () => void;
}

const SomethingWentWrong: React.FunctionComponent<SomethingWentWrongProps> = ({
  onRetryClick,
}) => {
  const router = useRouter();
  const { requestOrigin } = router.query;
  const isTrackedPage = requestOrigin === TRACKED;

  const errorMessage = isTrackedPage
    ? "load your Tracked Vehicles"
    : "retrieve your search results";

  return (
    <Box pt="15vh" pb="12.5vh" px="20px">
      <MessageTheme>
        <MessageIcon
          icon="exclamation-triangle"
          context="warning"
          size="large"
        />
        <Message title="Sorry, something went wrong..." textAlign="center">
          We were unable to {errorMessage}. Please try again or check back
          later. If this error persists please{" "}
          <StyledLink color="primary-light-blue" href={CONTACT_US_URL}>
            contact support
          </StyledLink>
          .
        </Message>
        <MessageOptionsContainer py="10px">
          <Button variant="secondary" width="160px" onClick={onRetryClick}>
            Retry
          </Button>
        </MessageOptionsContainer>
      </MessageTheme>
    </Box>
  );
};

export default SomethingWentWrong;
